import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CoursePlayer from './pages/CoursePlayer';
import Certificates from './pages/Certificates';
import Announcements from './pages/Announcements';
import Survey from './pages/Survey';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminCourses from './pages/admin/AdminCourses';
import AdminCourseDetail from './pages/admin/AdminCourseDetail';
import AdminUsers from './pages/admin/AdminUsers';
import AdminReports from './pages/admin/AdminReports';
import AdminCategories from './pages/admin/AdminCategories';
import AdminAnnouncements from './pages/admin/AdminAnnouncements';
import AdminCalendar from './pages/admin/AdminCalendar';
import AdminSurveyResults from './pages/admin/AdminSurveyResults';
import AdminTaskDashboard from './pages/admin/AdminTaskDashboard';
import AdminProjects from './pages/admin/AdminProjects';
import AdminTaskList from './pages/admin/AdminTaskList';
import AdminKanban from './pages/admin/AdminKanban';
import AdminGantt from './pages/admin/AdminGantt';
import AdminTaskReports from './pages/admin/AdminTaskReports';
import AdminTaskSettings from './pages/admin/AdminTaskSettings';
import AdminForms from './pages/admin/AdminForms';
import AdminDocuments from './pages/admin/AdminDocuments';
import FormPage from './pages/FormPage';
import AdminBulkEnroll from './pages/admin/AdminBulkEnroll';
import './index.css';

const PrivateRoute = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{minHeight:'100vh',background:'#f8f8f8'}} />;
  if (!user) return <Navigate to="/giris" />;
  if (adminOnly && user.role !== 'admin' && user.role !== 'manager') return <Navigate to="/panel" />;
  return children;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/giris" element={<Login />} />
          <Route path="/panel" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/egitim/:id" element={<PrivateRoute><CoursePlayer /></PrivateRoute>} />
          <Route path="/form/:slug" element={<FormPage />} />
          <Route path="/anket/:slug" element={<Survey />} />
          <Route path="/faaliyetler" element={<PrivateRoute><Announcements /></PrivateRoute>} />
          <Route path="/sertifikalar" element={<PrivateRoute><Certificates /></PrivateRoute>} />
          <Route path="/yonetim" element={<PrivateRoute adminOnly><AdminDashboard /></PrivateRoute>} />
          <Route path="/yonetim/egitimler" element={<PrivateRoute adminOnly><AdminCourses /></PrivateRoute>} />
          <Route path="/yonetim/egitimler/:id" element={<PrivateRoute adminOnly><AdminCourseDetail /></PrivateRoute>} />
          <Route path="/yonetim/kullanicilar" element={<PrivateRoute adminOnly><AdminUsers /></PrivateRoute>} />
          <Route path="/yonetim/belge-takibi" element={<PrivateRoute adminOnly><AdminDocuments /></PrivateRoute>} />
          <Route path="/yonetim/egitim-atama" element={<PrivateRoute adminOnly><AdminBulkEnroll /></PrivateRoute>} />
          <Route path="/yonetim/gorevler" element={<PrivateRoute adminOnly><AdminTaskDashboard /></PrivateRoute>} />
          <Route path="/yonetim/gorevler/projeler" element={<PrivateRoute adminOnly><AdminProjects /></PrivateRoute>} />
          <Route path="/yonetim/gorevler/liste" element={<PrivateRoute adminOnly><AdminTaskList /></PrivateRoute>} />
          <Route path="/yonetim/gorevler/gantt" element={<PrivateRoute adminOnly><AdminGantt /></PrivateRoute>} />
          <Route path="/yonetim/gorevler/raporlar" element={<PrivateRoute adminOnly><AdminTaskReports /></PrivateRoute>} />
          <Route path="/yonetim/formlar" element={<PrivateRoute adminOnly><AdminForms /></PrivateRoute>} />
          <Route path="/yonetim/gorevler/ayarlar" element={<PrivateRoute adminOnly><AdminTaskSettings /></PrivateRoute>} />
          <Route path="/yonetim/gorevler/kanban" element={<PrivateRoute adminOnly><AdminKanban /></PrivateRoute>} />
          <Route path="/yonetim/anket-sonuclari" element={<PrivateRoute adminOnly><AdminSurveyResults /></PrivateRoute>} />
          <Route path="/yonetim/takvim" element={<PrivateRoute adminOnly><AdminCalendar /></PrivateRoute>} />
          <Route path="/yonetim/faaliyetler" element={<PrivateRoute adminOnly><AdminAnnouncements /></PrivateRoute>} />
          <Route path="/yonetim/kategoriler" element={<PrivateRoute adminOnly><AdminCategories /></PrivateRoute>} />
          <Route path="/yonetim/raporlar" element={<PrivateRoute adminOnly><AdminReports /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/giris" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
